import apiClient from './api.service';
import { ImportSurveyResponse, SurveyExportPackage } from '../types/survey-copy';

class SurveyCopyService {
  async exportSurvey(surveyId: string): Promise<SurveyExportPackage> {
    const response = await apiClient.get<{ data: SurveyExportPackage }>(
      `/api/admin/surveys/${surveyId}/export`,
    );
    return response.data.data;
  }

  async importSurvey(payload: SurveyExportPackage): Promise<ImportSurveyResponse> {
    const response = await apiClient.post<{ data: ImportSurveyResponse }>('/api/admin/surveys/import', payload);
    return response.data.data;
  }
}

export const surveyCopyService = new SurveyCopyService();
